<template>
  <div class="component-wrapper video d-flex py-2">
    <v-progress-circular
      class="ma-auto"
      size="50"
      indeterminate
      color="primary"
      v-if="loader"
    ></v-progress-circular>

    <vueVimeoPlayer
      ref="player"
      :video-url="openedContent.storedPath"
      :controls="false"
      :options="vimeoOptions"
      @ready="onLoadVideo"
      @ended="onEnded"
      v-show="!loader"
    />
  </div>
</template>

<script>
  import { vueVimeoPlayer } from "vue-vimeo-player";
  import { mapActions, mapMutations, mapState } from "vuex";

  export default {
    components: { vueVimeoPlayer },
    data() {
      return {
        loadContentLoader: false,
        vimeoOptions: {
          muted: false,
          autopause: false
        },
        isPlayerReady: false
      };
    },
    computed: {
      ...mapState({
        openedContent: (state) => state.guide.openedContent,
      }),
      loader() {
        return (
          this.loadContentLoader ||
          !this.isPlayerReady
        );
      },
    },
    async created() {
      this.loadContentLoader = true;
      await this.loadContent(this.openedContent.hasSound);
      this.loadContentLoader = false;
    },
    methods: {
      ...mapMutations([
        "setOpenedContentFromPresentation",
        "setVideoPlayer",
        "setIsVideoPlaying",
        "setVideoPlayerReady"
      ]),
      ...mapActions(["loadContent", "loadVideo", "unloadContent"]),
      onLoadVideo() {
        this.isPlayerReady = true;
        this.setVideoPlayer(this.$refs.player);
        this.$store.commit("setVideoPlayerReady", true);
      },
      onEnded() {
        this.setIsVideoPlaying(false);
      }
    },
    async beforeRouteUpdate(to, from, next) {
      this.loadContentLoader = true;

      this.setOpenedContentFromPresentation();
      this.setIsVideoPlaying(false);
      
      await this.loadContent(this.openedContent.hasSound);

      this.loadContentLoader = false;

      next();
    },
    async beforeRouteLeave(to, from, next) {
      if (!to.path.includes("/IMAGE/")) this.unloadContent();

      this.setIsVideoPlaying(false);
      next();
    },
    watch: {
      'openedContent.hasSound'(val) {
        console.log("GUIDE hasSound changed:", val);
        this.vimeoOptions.muted = !val;
      }
    }
  };
</script>
